import commercialModule from "./commercial/commercial.module";
import angular from "angular";
import redirects from "./redirects.route";
import webAppsRoutes from "./web-apps.route";
import importModule from "./import/import.module";
import requestAccessModule from "./requestAccess/request_access.module";
import wbsModule from "./wbs/wbs.module";
import projectSettingsModule from "./projectSettings/project_settings.module";
import accountManagementModule from "./accountManagement/account_management.module";
import authModule from "./auth/auth.module";
import visualizationsModule from "./visualizations/visualizations.module";
import deliverablesModule from "./deliverables/deliverables.module";
import teamsModule from "./teams/teams.module";
import leanBoardModule from "./leanboard/lean_board.module";
import issuesModule from "./issues/issues.module";
import timelineModule from "./timeline/timeline.module";
import processViewerModule from "./processViewer/process_viewer.module";
import trackerModule from "./tracker/tracker.module";
import checklistTemplatesModule from "./checklistTemplates/checklist_templates.module";
import siteDiaryModule from "./siteDiary/site_diary.module";
import pageAccessService from "./page_access.service";
import pageNavigationService from "./page_navigation.service";

const moduleNames = [
    importModule,
    requestAccessModule,
    wbsModule,
    projectSettingsModule,
    accountManagementModule,
    commercialModule,
    visualizationsModule,
    deliverablesModule,
    teamsModule,
    leanBoardModule,
    issuesModule,
    timelineModule,
    processViewerModule,
    checklistTemplatesModule,
    siteDiaryModule,
    trackerModule,
    authModule,
].map(function (module) {
    return module.name;
});

export default angular
    .module("sbApp.states", ["ngMaterial"].concat(moduleNames))
    .config(redirects)
    .config(webAppsRoutes)
    .service("$sbPageAccess", pageAccessService)
    .service("$sbPageNavigation", pageNavigationService)
    .config(function ($mdAriaProvider) {
        "ngInject";
        $mdAriaProvider.disableWarnings();
    });
